<div class="wrapper w-75">
  <h1 class="title">Generell sökning</h1>
  <app-search-form [searchType]="searchType"></app-search-form>
</div>
